import * as React from 'react';
import { IconProps } from '../types';

const IcHide = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
   <path
      fill="#232F3E"
      d="M20.75 21a.746.746 0 0 1-.53-.22L3.72 4.28a.75.75 0 0 1 1.06-1.06l16.5 16.5a.75.75 0 0 1-.53 1.28Zm-8.266-3c-1.945 0-3.82-.576-5.574-1.71-1.597-1.032-3.035-2.51-4.158-4.266v-.004c.935-1.34 1.958-2.472 3.058-3.385a.094.094 0 0 0 .007-.138l-.934-.932a.094.094 0 0 0-.127-.006c-1.168.985-2.253 2.192-3.238 3.606a1.496 1.496 0 0 0-.03 1.666c1.238 1.937 2.83 3.569 4.606 4.718 2 1.295 4.151 1.951 6.39 1.951a11.21 11.21 0 0 0 3.553-.59.094.094 0 0 0 .036-.155l-1.011-1.011a.188.188 0 0 0-.18-.047 9.603 9.603 0 0 1-2.398.303Zm11.024-6.816c-1.24-1.918-2.85-3.547-4.653-4.712-1.996-1.29-4.199-1.972-6.371-1.972a10.657 10.657 0 0 0-3.51.601.094.094 0 0 0-.036.156l1.01 1.01a.188.188 0 0 0 .182.047A9.04 9.04 0 0 1 12.484 6c1.907 0 3.777.583 5.557 1.734 1.627 1.05 3.082 2.526 4.208 4.266v.008a14.567 14.567 0 0 1-3.006 3.409.096.096 0 0 0-.034.067.094.094 0 0 0 .027.071l.933.932a.094.094 0 0 0 .126.007 16.104 16.104 0 0 0 3.218-3.68 1.51 1.51 0 0 0-.005-1.63Z"
    />
    <path
      fill="#232F3E"
      d="M12.5 7.5c-.337 0-.673.038-1.002.112a.094.094 0 0 0-.071.116.093.093 0 0 0 .024.043l5.278 5.276c.012.012.027.02.043.025a.094.094 0 0 0 .116-.072A4.501 4.501 0 0 0 12.5 7.5Zm-4.23 3.453a.095.095 0 0 0-.092-.024.093.093 0 0 0-.066.07 4.5 4.5 0 0 0 5.391 5.391.093.093 0 0 0 .07-.065.093.093 0 0 0-.023-.093l-5.28-5.28Z"
    />
  </svg>
);

export default IcHide;
